import * as types from "@/store/types";

const state = {
  userSetting: {
    wallet: {
      setting: {
        assets_currency_type: "IRR",
        display_currency_type: "name_locale"
      },
      hide_zero_assets: false,
      arrange: []
    },
    order: {
      base_currency: "IRR"
    }
  }
};

const getters = {
  [types.userSetting.getters.GET_USER_SETTING]: state => {
    return state.userSetting;
  }
};

const mutations = {
  [types.userSetting.mutations.MUTATE_USER_SETTING]: (state, payload) => {
    state.userSetting = payload;
  }
};

const actions = {
  [types.userSetting.actions.SET_USER_SETTING]: ({ commit }, payload) => {
    commit(types.userSetting.mutations.MUTATE_USER_SETTING, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
